import { render } from "./ContextMenu.vue?vue&type=template&id=71e96be2"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"

import "./ContextMenu.vue?vue&type=style&index=0&id=71e96be2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__